import { render, staticRenderFns } from "./EditJobBenefits.vue?vue&type=template&id=ee736d58&"
import script from "./EditJobBenefits.vue?vue&type=script&lang=js&"
export * from "./EditJobBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports